export default __webpack_public_path__ + "static/media/official_partner_national_projects.7c7c7bcc.pdf";